import {useFormik} from 'formik';
import * as Yup from 'yup';
import {EditRegionDTO, useRegionById} from '../../../entities';
import {AxiosError} from 'axios';
import {useSchemes} from '../../../shared';

interface UseEditRegionFormProps {
  setOpen: (open: boolean) => void;
  regionId: string | null;
}

export const useEditRegionForm = ({setOpen, regionId}: UseEditRegionFormProps) => {
  const {getRegion, updateRegionMutation} = useRegionById(regionId || '');
  const {nameSchema, orderSchema} = useSchemes();

  const onSubmit = async (values: EditRegionDTO) => {
    const {name, order} = values;
    try {
      if (regionId) {
        await updateRegionMutation.mutateAsync({
          regionId,
          name,
          order,
        });
      }
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: getRegion.data?.name || '',
      order: getRegion.data?.order || 0,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: nameSchema,
      order: orderSchema,
    }),
    onSubmit: onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    isLoading: updateRegionMutation.isPending || getRegion.isLoading,
    submitError: updateRegionMutation.error
      ? (updateRegionMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
  };
};
